import { render } from "./Home.vue?vue&type=template&id=e2a3b5de"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script